import { render, staticRenderFns } from "./DeliveryDialog.vue?vue&type=template&id=3d3a7e5a&scoped=true&"
import script from "./DeliveryDialog.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDialog.vue?vue&type=style&index=0&id=3d3a7e5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3a7e5a",
  null
  
)

export default component.exports